import mongoose from "mongoose";
import { nanoid } from "nanoid";
import { match } from "@mssi/pssp-shared";

export interface Site {
  _id: mongoose.Schema.Types.ObjectId;
  id: string;
  itsmCustomerId: string;
  siteName: string;
  name1: string;
  name2?: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  stateOrProvince: string;
  postalCode: string;
  country: string;
  buildingId: string;
  bpid: string;
  shipToNumber: string; // scid
}

export const SiteSchema = new mongoose.Schema<Site>({
  id: { type: String, index: true, unique: true, default: () => nanoid() },
  itsmCustomerId: { type: String, index: true },
  siteName: String,
  name1: String,
  name2: String,
  addressLine1: String,
  addressLine2: String,
  city: String,
  stateOrProvince: String,
  postalCode: String,
  country: String,
  buildingId: String,
  bpid: String,
  shipToNumber: String, // cbn / crs / scid
});

export const props: (keyof Site)[] = [
  "itsmCustomerId",
  "siteName",
  "name1",
  "name2",
  "addressLine1",
  "addressLine2",
  "city",
  "stateOrProvince",
  "postalCode",
  "country",
  "buildingId",
  "bpid",
];

export function matches(a: Site, b: Site) {
  return match(a, b, props);
}

export const siteUtils = {
  props,
  matches,
};
